import { useEffect, useState } from "react";
import { Spin, Button, Form, Input, notification } from "antd";

import "antd/dist/reset.css";
import "./App.css";

import { Context } from "./context";
import { parseJwt } from "./utils";
import AdminModule from "./components/AdminModule";

const App = () => {
  let apiUrl = "";
  let transcodeUrl = "https://transcode.ibee.ai/rl";

  if (window.location.href.includes("http://localhost")) {
    // apiUrl = "http://localhost:8000";
     apiUrl = "https://rl-api.fastpix.com";
    //  apiUrl = "https://qa-rl-api.fastpix.in";
  } else if (window.location.href.includes("https://qa-rl-cms.fastpix.in")) {
    apiUrl = "https://qa-rl-api.fastpix.in";
  } else if (window.location.href.includes("https://rl-cms.fastpix.com")) {
    apiUrl = "https://rl-api.fastpix.com";
  }

  const [signedIn, setSignedIn] = useState(false);
  const [data, setData] = useState(false);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [superAdmin, setSuperAdmin] = useState(false);
  const [initialTab, setInitialTab] = useState("dashboard");

  const [form] = Form.useForm();

  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    if (token) {
      setToken(token);
      setSignedIn(true);
    } else if (!token) {
      setData(true);
      return;
    }
    const email = sessionStorage.getItem("user_email");
    if (email) {
      setUserEmail(email);
    }

    const isSuperAdmin = sessionStorage.getItem("superadmin");
    if (isSuperAdmin) {
      isSuperAdmin === "true" ? setSuperAdmin(true) : setSuperAdmin(false);
    }

    const initialTab = sessionStorage.getItem("lastNav");
    if (initialTab) {
      setInitialTab(initialTab);
    }
    setTimeout(() => {
      setData(true);
    }, 600);
  }, []);
  if (!data) {
    return <Spin className="loading-container" size="large" />;
  }

  const handleLoginSubmit = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("username", form.getFieldValue("username"));
    formData.append("password", form.getFieldValue("password"));
    formData.append("client_id", "admin");

    fetch(`${apiUrl}/oauth2/token`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((result) => {
        sessionStorage.setItem("access_token", result["access_token"]);
        setToken(result["access_token"]);
        setSignedIn(true);
        sessionStorage.setItem("user_email", form.getFieldValue("username"));
        setUserEmail(form.getFieldValue("username"));
        const jwt = parseJwt(result["access_token"]);
        sessionStorage.setItem("superadmin", jwt.superadmin);
        setSuperAdmin(jwt["superadmin"]);
      })
      .catch((error) => {
        if (error.message === "401") {
          notification.error({
            message: "Error",
            description: "Invalid username/password",
          });
        }
        console.error("There is a problem with fetch operation: ", error);
      })
      .finally(() => setLoading(false));
  };

  if (signedIn) {
    return (
      <Context.Provider value={{ token, apiUrl, transcodeUrl, superAdmin }}>
        <AdminModule userEmail={userEmail} initialTab={initialTab} />
      </Context.Provider>
    );
  } else {
    return (
      <div className="login-form">
        <img src="/images/login.png" className="logo" alt="MiniPix" />
        <Form form={form} layout="vertical" onFinish={handleLoginSubmit}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Username Mandatory" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Password Mandatory" }]}
          >
            <Input type="password" />
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              style={{ color: "#ffffff" }}
              disabled={loading}
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
};

export default App;
